import { Swiper } from 'swiper';
import { A11y, Navigation, Autoplay, Pagination } from 'swiper/modules';

const sliders = document.querySelectorAll(
	'.acf-block:not(.block-testimonial-cards) .block-testimonials .swiper'
);

if (sliders.length > 0) {
	sliders.forEach((slider, index) => {
		const slides = slider.querySelectorAll('.swiper-slide');
		const parentElement = slider.parentElement;
		const navigationContainer = parentElement.querySelector(
			'.block-testimonials__navigation'
		);

		// Check if this is within a testimonial-standard block
		const isTestimonialStandard =
			parentElement.closest('.block-testimonial-standard') !== null;
		const autoplayEnabled = isTestimonialStandard;

		// Build navigation from testimonial block data
		if (navigationContainer && slides.length > 1) {
			let hasNavData = false;
			const navHTML = [];

			slides.forEach((slide, slideIndex) => {
				const sliderImage = slide.dataset.sliderImage;
				const sliderTitle = slide.dataset.sliderTitle;

				if (sliderImage || sliderTitle) {
					hasNavData = true;
					let buttonContent = '';

					if (sliderImage) {
						// Use image if URL is provided
						buttonContent = `<img src="${sliderImage}" alt="${sliderTitle || `Slide ${slideIndex + 1}`}" class="block-testimonials__nav-image" />`;
					} else if (sliderTitle) {
						buttonContent = `<span class="block-testimonials__nav-title">${sliderTitle}</span>`;
					}

					navHTML.push(`
						<button 
							class="block-testimonials__nav-item${slideIndex === 0 ? ' active' : ''}" 
							data-slide-index="${slideIndex}"
							role="tab"
							aria-selected="${slideIndex === 0 ? 'true' : 'false'}"
							aria-controls="testimonial-slide-${slideIndex}"
						>
							${buttonContent}
						</button>
					`);
				}
			});

			if (hasNavData) {
				navigationContainer.innerHTML = navHTML.join('');
				navigationContainer.style.display = '';
			}
		}

		const navButtons = parentElement.querySelectorAll(
			'.block-testimonials__nav-item'
		);

		parentElement.classList.add(`block-testimonials__swiper--${index}`);

		// Build modules array based on features needed
		const modules = [A11y, Navigation, Pagination];
		if (isTestimonialStandard && slides.length > 1) {
			modules.push(Autoplay);
		}

		const settings = {
			loop: slides.length > 1 ? true : false,
			grabCursor: true,
			spaceBetween: 32,
			slidesPerView: 1,
			modules,
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl: `.block-testimonials__swiper--${index} .swiper-button-prev`,
				nextEl: `.block-testimonials__swiper--${index} .swiper-button-next`,
			},
			pagination: {
				el: `.block-testimonials__swiper--${index} .swiper-pagination`,
				clickable: true,
				dynamicBullets: true,
				dynamicMainBullets: 3,
			},
			// Add autoplay configuration for testimonial-standard blocks
			...(isTestimonialStandard && slides.length > 1
				? {
						autoplay: {
							delay: 5000, // 5 seconds between slides
							disableOnInteraction: false, // Don't permanently disable, just pause
							pauseOnMouseEnter: true,
							reverseDirection: false,
						},
					}
				: {}),
			on: {
				init() {
					// Store autoplay state
					this.autoplayStarted = autoplayEnabled;
				},
				slideChange() {
					// Update active navigation button
					navButtons.forEach((btn, btnIndex) => {
						if (btnIndex === this.realIndex) {
							btn.classList.add('active');
							btn.setAttribute('aria-selected', 'true');
						} else {
							btn.classList.remove('active');
							btn.setAttribute('aria-selected', 'false');
						}
					});
				},
				reachEnd() {
					// When reaching the end, reverse the autoplay direction
					if (
						this.autoplay &&
						this.autoplay.running &&
						isTestimonialStandard
					) {
						this.autoplay.stop();
						this.params.autoplay.reverseDirection = true;
						this.autoplay.start();
					}
				},
				reachBeginning() {
					// When reaching the beginning, reverse the autoplay direction again
					if (
						this.autoplay &&
						this.autoplay.running &&
						isTestimonialStandard
					) {
						this.autoplay.stop();
						this.params.autoplay.reverseDirection = false;
						this.autoplay.start();
					}
				},
			},
		};

		const swiperInstance = new Swiper(slider, settings);

		// Add click handlers to navigation buttons
		navButtons.forEach((button) => {
			button.addEventListener('click', () => {
				const slideIndex = parseInt(button.dataset.slideIndex);
				if (!isNaN(slideIndex)) {
					// Stop autoplay on user interaction
					if (
						swiperInstance.autoplay &&
						swiperInstance.autoplay.running &&
						isTestimonialStandard
					) {
						swiperInstance.autoplay.stop();
					}
					swiperInstance.slideTo(slideIndex);
				}
			});
		});

		// Stop autoplay when arrow buttons are clicked
		if (isTestimonialStandard) {
			const prevButton = parentElement.querySelector(
				'.swiper-button-prev'
			);
			const nextButton = parentElement.querySelector(
				'.swiper-button-next'
			);

			if (prevButton) {
				prevButton.addEventListener('click', () => {
					if (
						swiperInstance.autoplay &&
						swiperInstance.autoplay.running
					) {
						swiperInstance.autoplay.stop();
					}
				});
			}

			if (nextButton) {
				nextButton.addEventListener('click', () => {
					if (
						swiperInstance.autoplay &&
						swiperInstance.autoplay.running
					) {
						swiperInstance.autoplay.stop();
					}
				});
			}

			// Also stop autoplay on direct slide interaction (touch/drag)
			slider.addEventListener(
				'touchstart',
				() => {
					if (
						swiperInstance.autoplay &&
						swiperInstance.autoplay.running
					) {
						swiperInstance.autoplay.stop();
					}
				},
				{ passive: true }
			);

			slider.addEventListener('mousedown', () => {
				if (
					swiperInstance.autoplay &&
					swiperInstance.autoplay.running
				) {
					swiperInstance.autoplay.stop();
				}
			});
		}
	});
}
